import $ from 'jquery';
import whatInput from 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
// import Foundation from 'foundation-sites';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import './lib/navigation';


$(document).foundation();

$(document).on('click', 'a[href^="#"]:not([role="tab"]):not([data-open]):not([data-toggle])', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});

$(document).ready(function() {
    var elem = $('#site-status-message');
    Foundation.Motion.animateIn(elem, 'slide-in-down');

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search.slice(1))
    params.delete('tour');
    // params.delete('status');
    // params.delete('button_link');
    // params.delete('button_text');
    // params.delete('autoclose');
    var newURL = `${window.location.pathname}`;
    // console.log(params);
    if (params.size) {
        newURL = `${window.location.pathname}?${params}${window.location.hash}`;
    }
    window.history.replaceState(
        {},
        '',
        newURL
    );
});